import ApiService from '@/services/api.service'

const ReportsService = {
    getAll( parameter) { 
         
      const requestData = {
        method: 'get',
        url: "/Reports",
        headers: {
        },
        params: { 
          SearchCriteria: parameter.SearchCriteria,
          PageSize: parameter.PageSize,          
          PageNumber : parameter.PageNumber,
        }
      }     
      return ApiService.customRequest(requestData);         
    },
  
    get(id) {
      return ApiService.get(`/Reports/${id}`);
    },

    add(data){
      return ApiService.post(`/Reports`,data)
    },

    delete(id){
      return ApiService.delete(`/Reports/${id}`)
    },

    update(Code,data){
      return ApiService.put(`/Reports/${Code}`,data)
    },

    savedReports() {
      return ApiService.get(`/Reports/SavedReports`);
    },
}
  
export default ReportsService;